import { el, setAttr } from 'redom';

import Tooltip from 'generics/components/tooltip/native';

import './index.scss';

class ToggleInput {

  constructor(configuration) {

    this.tooltip = null;

    this.offModeValue = configuration.off || false;
    this.onModeValue = configuration.on || true;
    this.status = this.determineStatus(configuration.value);
    this.onChange = configuration.onChange;
    this.disabled = configuration.disabled || false;

    this.el = el('.toggle-input', {
      disabled: this.disabled,
      onclick: this.toggle.bind(this)
    });

    if (configuration.tooltip !== false) {
      this.tooltip = new Tooltip({
        content: '',
        target: this.el
      });
    }

    this.applyStatus();

  }

  setReadOnly(readOnly) {

    this.disabled = readOnly;

    setAttr(this.el, {
      disabled: this.disabled
    });

  }

  disable() {

    this.setReadOnly(true);

  }

  enable() {

    this.setReadOnly(false);

  }

  determineStatus(status) {

    if (this.onModeValue === status) {
      return true;
    }

    return false;

  }

  getStatus() {

    return this.status;

  }

  setStatus(status) {

    this.status = status;

    this.applyStatus();

    this.updateTooltip();

  }

  getValue() {

    if (this.status === true) {
      return this.onModeValue;
    } else {
      return this.offModeValue;
    }

  }

  setValue(value) {

    this.status = this.determineStatus(value);

    this.applyStatus();

    this.updateTooltip();

  }

  applyStatus() {

    if (this.status === true) {
      this.el.classList.add('on');
    } else {
      this.el.classList.remove('on');
    }

  }

  updateTooltip() {

    if (this.tooltip === null) {
      return;
    }

    this.tooltip.update({
      content: this.getValue()
    });

  }

  propogateChange() {

    let value = this.getValue();

    this.onChange(value, this.getStatus());

  }

  toggle() {

    if (this.disabled === true) {
      return;
    }

    this.status = this.status === false;

    this.applyStatus();
    this.updateTooltip();

    this.propogateChange();

  }

  update(configuration) {

    this.status = this.determineStatus(configuration.value);

    this.applyStatus();

    this.updateTooltip();

  }

}

export default ToggleInput;